<script setup lang="ts">
    import { computed } from 'vue'
    import PkUrl from '../PkUrl.vue'

    const props = defineProps<{
        part: unknown
    }>()

    const toolPart = computed(() => {
        const part = props.part as {
            output?: {
                products: Array<{
                    name: string
                    url?: string
                    image?: string
                    price?: string
                    availability?: string
                    description?: string
                }>
            }
        }
        return part
    })

    const getAvailabilityColor = (availability?: string) => {
        if (!availability) {
            return ''
        }
        const lower = availability.toLowerCase()
        if (
            lower.includes('in stock') ||
            lower.includes('available') ||
            lower.includes('disponibile')
        ) {
            return 'text-success'
        }
        if (
            lower.includes('out of stock') ||
            lower.includes('unavailable') ||
            lower.includes('non disponibile')
        ) {
            return 'text-danger'
        }
        if (
            lower.includes('limited') ||
            lower.includes('low stock') ||
            lower.includes('limitato')
        ) {
            return 'text-warning'
        }
        return 'text-word-3'
    }
</script>

<template>
    <ul
        v-if="toolPart?.output?.products?.length"
        class="flex flex-col gap-xs w-full">
        <li
            v-for="(product, index) in toolPart.output.products"
            :key="index"
            class="border border-surface-3 rounded-lg overflow-hidden hover:border-surface-4 transition-colors">
            <component
                :is="product.url ? 'a' : 'div'"
                :href="product.url"
                :target="product.url ? '_blank' : undefined"
                :rel="product.url ? 'noopener noreferrer' : undefined"
                class="flex gap-8 p-8 hover:bg-surface-1 transition-colors">
                <img
                    v-if="product.image"
                    :src="product.image"
                    :alt="product.name"
                    class="w-48 h-48 object-cover rounded shrink-0" />
                <div class="flex flex-col gap-4 min-w-0 flex-1">
                    <strong class="font-bold text-12 text-word-1 truncate">
                        {{ product.name }}
                    </strong>
                    <span
                        v-if="product.url"
                        class="text-10 text-word-4 truncate flex items-center gap-4">
                        <VvIcon name="ri:link" class="shrink-0 text-12" />
                        <PkUrl :url="product.url" />
                    </span>
                    <div class="flex items-center gap-sm flex-wrap text-12">
                        <span
                            v-if="product.price"
                            class="font-semibold text-word-1">
                            {{ product.price }}
                        </span>
                        <span
                            v-if="product.availability"
                            class="text-10 font-medium"
                            :class="getAvailabilityColor(product.availability)">
                            {{ product.availability }}
                        </span>
                    </div>
                    <p
                        v-if="product.description"
                        class="text-12 text-word-3 line-clamp-2">
                        {{ product.description }}
                    </p>
                </div>
            </component>
        </li>
    </ul>
</template>
